<div [ngClass]="fieldClass">
  <mat-slide-toggle [formControl]="control" [labelPosition]="labelPosition">
    <span class="font-medium">
      {{ label }}
    </span></mat-slide-toggle
  >
  <mat-error siatErrorField [control]="control" [label]="label"></mat-error>
</div>
